module.exports = __webpack_public_path__ + "static/chaos-colleagues-3fec5da69992e92585adf224d1d5ff7a.jpg";